import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ControlledInput from 'js/components/controlled_input/index';

class PostalCodeInput extends Component {
    static propTypes = {
        value: PropTypes.string
    };

    shouldComponentUpdate(nextProps) {
        return nextProps.value !== this.props.value;
    }

    render() {
        return (
            <ControlledInput
                {...this.props}
                name="profile[zip_code]"
                label="Postal Code"
                placeholder=""
            />
        );
    }
}

export default PostalCodeInput;



// WEBPACK FOOTER //
// ./creator/components/address_info_form/components/postal_code_input.js